import { default as en } from '../constants/languages/en';
import { get, stringToPath } from './accessors';

const languages: Record<string, typeof en> = {
  en,
};

export default function translate(lang = 'en', key: string) {
  return get(languages[lang], stringToPath(key));
}
